export default {
  SET_TIME_OFFS: (state, payload) => (state.timeOffs = payload),
  SET_TIME_OFF: (state, payload) => (state.timeOff = payload)
}
